import React from 'react';
import { useAppSelector } from 'src/store';
import KayitliKimlikler from 'src/content/pages/Kimlik/KayitliKimlikler';
import HastaKaraListesi from './Liste';
import HastaKaraListesiEkle from './Ekle';

const HastaKaraListesiEkrani = (): JSX.Element => {
    const state = useAppSelector(s => s.hastaKaraListe);
    const kimlikState = useAppSelector(s => s.kimlik);
    return (
        <>
            {state.open && <HastaKaraListesi />}
            {state.ekleOpen && <HastaKaraListesiEkle />}
            {kimlikState.kayitliKimliklerOpen && <KayitliKimlikler />}
        </>
    );
};

export default HastaKaraListesiEkrani;